import React from 'react';

import { Thead } from '@chakra-ui/react';
import styled from '@emotion/styled';

const StyledThead = styled(Thead)`
  background: ${(props) => props.theme.colors.neutral.F5F7F9};
  border-radius: 4px;
`;

const TableHead = ({ children, ...props }) => <StyledThead {...props}>{children}</StyledThead>;

export { TableHead };
